import { getRequest } from "../app/postRequest.service";
import { MemberEnrolmentResponse } from "../interfaces/enrollment.interface";
import { RouteConstant as rc } from "../common/common.constants";

export function enrolmentsApi() {
  return new Promise<{ data: MemberEnrolmentResponse }>((resolve) =>
    resolve(getRequest(rc.MEMBER_ENROLLMENT))
  );
}